// Local translations
export const T = {
  en_GB: {
    info: "Details",
    close: "Close",
  },
  nb_NO: {
    info: "Detaljer",
    close: "Lukk",
  },
} as const;
